import { useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';
import { useChatStore } from '../stores/chatStore';
import { connectSocket, disconnectSocket } from '../services/socket';

export function useSocketConnection() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const addMessage = useChatStore((s) => s.addMessage);
  const fetchRooms = useChatStore((s) => s.fetchRooms);
  const fetchTotalUnread = useChatStore((s) => s.fetchTotalUnread);
  const setTyping = useChatStore((s) => s.setTyping);

  useEffect(() => {
    if (!isAuthenticated) {
      disconnectSocket();
      return;
    }

    let socket: ReturnType<typeof connectSocket>;
    try {
      socket = connectSocket();
    } catch {
      return;
    }

    // 채팅 메시지 수신
    socket.on('chat:message', (message) => {
      addMessage(message);
      fetchRooms();
    });

    // 타이핑 표시
    socket.on('chat:typing', ({ userId, isTyping, roomId }: { userId: string; isTyping: boolean; roomId: string }) => {
      setTyping(roomId, userId, isTyping);
    });

    // 읽음 처리
    socket.on('chat:read', () => {
      // 읽음 상태 갱신
    });

    // 채팅 미읽음 갱신
    socket.on('chat:unread', () => {
      fetchTotalUnread();
      fetchRooms();
    });

    // 알림 수신 → DOM 이벤트로 브릿지
    socket.on('notification:new', (notification) => {
      window.dispatchEvent(new CustomEvent('notification:new', { detail: notification }));
    });

    fetchTotalUnread();

    return () => {
      socket.off('chat:message');
      socket.off('chat:typing');
      socket.off('chat:read');
      socket.off('chat:unread');
      socket.off('notification:new');
    };
  }, [isAuthenticated, addMessage, fetchRooms, fetchTotalUnread, setTyping]);
}
